/**
 * Test IDs for QA automation.
 */
export const testIds = {
  transactionFormModalCancel: "transaction-form-modal-cancel",
  transactionFormModalValidate: "transaction-form-modal-validate",
} as const;
